import axios from 'axios';

const AxiosPublic = () => {
    const axiosPublic=axios.create({
        baseURL:"https://toporion.net/api",
        // baseURL:"http://localhost:8080/api",
    })
    return axiosPublic;
};

export default AxiosPublic;